import { render, staticRenderFns } from "./BaseEmpty.vue?vue&type=template&id=ab6bf6ba&scoped=true"
import script from "./BaseEmpty.vue?vue&type=script&lang=js"
export * from "./BaseEmpty.vue?vue&type=script&lang=js"
import style0 from "./BaseEmpty.vue?vue&type=style&index=0&id=ab6bf6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6bf6ba",
  null
  
)

export default component.exports